import { path } from 'ramda';
import { ADD_APPOINTMENT } from '../register/order/constants';
import { getIsRentalShop } from '../auth/selectors';
import { getIsOnlyOneBarberSelected } from '../register/order/selectors';
import { addAppointmentItem, resetOrder } from '../register/order/actions';
import {
  charge,
  setActiveBarber,
} from '../register/sale/actions';
import { setPromoCode } from '../register/promo/actions';
import { setCard } from '../register/customer/actions';

const chargeAppointmentMiddleware = store => next => (action) => {
  const state = store.getState();
  switch (action.type) {
    case ADD_APPOINTMENT: {
      const barberId = path(['payload', 'barberId'], action);
      const appointmentItem = path(['payload', 'item'], action);
      const promoCode = path(['payload', 'item', 'promos', '0', 'customer_promo', 'promo', 'code'], action);
      if (getIsRentalShop(state) && !getIsOnlyOneBarberSelected(state, { id: barberId })) {
        store.dispatch(resetOrder());
      }
      store.dispatch(setActiveBarber(barberId));
      store.dispatch(setCard());
      if (promoCode) {
        store.dispatch(setPromoCode(promoCode));
      }
      store.dispatch(addAppointmentItem(barberId, appointmentItem));
      store.dispatch(charge());
      break;
    }
    default:
  }
  next(action);
};

export default chargeAppointmentMiddleware;
